import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronsOutwardIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ChevronsOutward",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.86 23.86c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l6.05-6.05-6.05-6.05a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l6.86 6.86a1.16 1.16 0 0 1 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33M7.86 23.86c-.29 0-.58-.11-.81-.33L.19 16.67a1.16 1.16 0 0 1 0-1.62l6.86-6.86a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-6.05 6.05 6.05 6.05a1.14 1.14 0 0 1-.81 1.95"
    })
  }));
};
ChevronsOutwardIcon.displayName = 'ChevronsOutwardIcon';